// Astrea Ops - AI for the Project Details form (v7.97, 19 Oct 2026).
//
// Asks /api/ai-project-form to fill the Project Details form: the client organisation's official
// details from the web, and contacts, scope and so on from material the planner adds. The app
// writes what comes back onto the project and marks each value AI for review (src/App.jsx).
import { authHeaders } from './apiAuth';

export async function fillProjectForm({ project, currentFields = {}, mode = 'search', text = '', documents = [] }, { signal } = {}) {
  const r = await fetch('/api/ai-project-form', {
    method: 'POST',
    headers: await authHeaders(),
    body: JSON.stringify({ project, currentFields, mode, text, documents }),
    signal,
  });
  let data = {};
  try { data = await r.json(); } catch (e) { data = {}; }
  if (!r.ok) throw new Error(data.error || ('The AI request failed (HTTP ' + r.status + ').'));
  return {
    fields: data.fields && typeof data.fields === 'object' ? data.fields : {},
    message: data.message || '',
    sourcesUsed: Array.isArray(data.sourcesUsed) ? data.sourcesUsed : [],
    truncated: !!data.truncated,
  };
}
